export default {
    name: 'ContextEntityIds',
    properties: {
        /**
         * @name __constructor__
         * @description By default a model is an object with properties. __constructor__ can be used to define a different type of model.
         * @example
         * {
         *      "my_map": {
         *        "key1": ["a", "b"]
         *      }
         *    }
         * For example, if we want to model "my_map", that is an object with dynamic keys with an array as values, we can
         * map it defining an array as the model type:
         *
         * const IdsModel = {
         *      ...
         *      properties: {
         *        __constructor__: { type: 'array', name: 'ids', mapKey: 'entity' } as ModelPropertyConfig<Array<string>>,
         *      },
         *    };
         *
         * const model = {
         *      ...
         *      properties: {
         *        ...
         *        my_map: { type: 'map', model: IdsModel } as ModelPropertyConfig<MapModel<typeof IdsModel>>,
         *        ...
         *      },
         *    };
         */
        __constructor__: { type: 'array', name: 'entityIds' },
    },
};
